/* eslint-disable */

let icaalQuoteValues = {};

  jQuery(function($){

    const $formPaneCount = $('.pane').length;
    const $progressBarInterval = 100 / $formPaneCount;
    const $progressBar = $('.progress-bar');
    $progressBar.css('width', $progressBarInterval + '%');
    

/************ Adds or Removes Checked Class for Services Pane *************/

    $('.option').click( function () {
      const $this = $(this);
      if ($this.hasClass('clicked')) {
        $this.removeClass('clicked');
      } else {
        $this.addClass('clicked');
      }
    });

/******************************* Next Pane ********************************/
    
    function nextPane() {

      const $form = $('.icaal__quote-form');
      let $active = $form.find('.pane.active');// Finds Current Active Pane
      let $next = $active.next(); // Finds Next Pane
      let pane = $next.attr('data-pane'); // Fetches Data-Pane Value
      let $activeIndex = pane;

      if( $('[data-name="image-upload"]').hasClass('active')) {
        $progressBar.css('width', $progressBarInterval * $activeIndex + '%')
        $active.removeClass('active');
        $next.addClass('active');
      } else if(services.includes( 'Body Repairs' ) || services.includes( 'Respray' ) || services.includes( 'Classic Car Restoration' )) {
        $progressBar.css('width', $progressBarInterval * $activeIndex + '%')
        $active.removeClass('active');
        $next.addClass('active');
      } else {
        $active.removeClass('active'); 
        $('[data-name="image-upload"]').addClass('active');
        pane = $('[data-name="image-upload"]').attr('data-pane');
        $activeIndex = pane;
        $progressBar.css('width', $progressBarInterval * $activeIndex + '%')
      }
    }

/******************************* Prev Pane ****************************/

    function prevPane() {

      const $form = $('.icaal__quote-form');
      let $active = $form.find('.pane.active'); // Finds Current Active Pane
      let $prev = $active.prev(); // Finds previous Pane
      let pane = $prev.data(pane);
      let $activeIndex = pane.pane;

      if(services.includes( 'Body Repairs' ) || services.includes( 'Respray' ) || services.includes( 'Classic Car Restoration' )) {
        $progressBar.css('width', $progressBarInterval * $activeIndex + '%')
        $active.removeClass('active');
        $prev.addClass('active');
      } else {
        $active.removeClass('active'); 
        $('[data-name="services"]').addClass('active');
        pane = $('[data-name="services"]').attr('data-pane');
        $activeIndex = pane;
        $progressBar.css('width', $progressBarInterval * $activeIndex + '%')
      }
    }

/***************************** Pane Navigation ****************************/

    $('.nextBtn').click( function(event) {
        event.preventDefault();
        nextPane();
    });

    $('.backBtn').click( function(event) {
      event.preventDefault();
      prevPane();
     });

/************************ Pane Array Functions ****************************/

    let services =  [];
    $('.option').on('click', function() {
      let value = $(this).find('input').attr('value');
      if(services.includes(value)) {
        let index = services.indexOf(value); // Finds index of value
        if (index > -1) {
        services.splice(index, 1); // removes index from array
        }
      } else {
        services.push(value);
      }
        services = services.join(' , ');
    });

    let driversSide = [];
    $(".dSide input[type=checkbox]").on('click', function() {
      value = $(this).val();
      if(driversSide.includes(value)) {
        let index = driversSide.indexOf(value);
        if (index > -1) {
        driversSide.splice(index, 1);
        }
      } else {
        driversSide.push(value);
      }
      console.log(driversSide);
    });

    let passengerSide = [];
    $(".pSide input[type=checkbox]").on('click', function() {
      value = $(this).val();
      if(passengerSide.includes(value)) {
        let index = passengerSide.indexOf(value);
        if (index > -1) {
        passengerSide.splice(index, 1);
        }
      } else {
        passengerSide.push(value);
      }
      console.log(passengerSide);
    });

    let topView = [];
    $(".top input[type=checkbox]").on('click', function() {
      value = $(this).val();
      if(topView.includes(value)) {
        let index = topView.indexOf(value);
        if (index > -1) {
        topView.splice(index, 1);
        }
      } else {
        topView.push(value);
      }
      console.log(topView);
    });

    let frontView = [];
    $(".front input[type=checkbox]").on('click', function() {
      value = $(this).val();
      if(frontView.includes(value)) {
        let index = frontView.indexOf(value);
        if (index > -1) {
        frontView.splice(index, 1);
        }
      } else {
        frontView.push(value);
      }
      console.log(frontView);
    });

    let rearView = [];
    $(".rear input[type=checkbox]").on('click', function() {
      value = $(this).val();
      if(rearView.includes(value)) {
        let index = rearView.indexOf(value);
        if (index > -1) {
        rearView.splice(index, 1);
        }
      } else {
        rearView.push(value);
      }
      console.log(rearView);
    });

    $('#reg').on('change keyup', function(e) {
      let name = $(this).attr('name');
      let value = $(this).val();
      icaalQuoteValues[name] = value;
      console.log(icaalQuoteValues);
    });

    $('.details input, .details textarea').on('keyup', function() {
      let name = $(this).attr('name');
      let value = $(this).val();
      icaalQuoteValues[name] = value;
      console.log(icaalQuoteValues);
    });
    
/***************************** Image Upload Input ********************************/

    const imageInput = $('input[type=file]');

    let preview = $('.imgPreview');
    let preview2 = $('.imgPreview2');
    let preview3 = $('.imgPreview3');
    let preview4 = $('.imgPreview4');
    let preview5 = $('.imgPreview5');
    const text = $('.defaultText');

    imageInput.on('change', function () {

      let file = this.files[0];
      let file2 = this.files[1];
      let file3 = this.files[2];
      let file4 = this.files[3];
      let file5 = this.files[4];   
      
      if (file) {
        const reader = new FileReader();
        reader.addEventListener('load', function () {
          preview.attr('src', this.result);
          preview.show();
          text.hide();
        });
        reader.readAsDataURL(file);
      }
      if (file2) {
        const reader = new FileReader();
        reader.addEventListener('load', function () {
          preview2.attr('src', this.result);
          preview2.show();
        });
        reader.readAsDataURL(file2);
      }
      if (file3) {
        const reader = new FileReader();
        reader.addEventListener('load', function () {
          preview3.attr('src', this.result);
          preview3.show();
        });
        reader.readAsDataURL(file3);
      }
      if (file4) {
        const reader = new FileReader();
        reader.addEventListener('load', function () {
          preview4.attr('src', this.result);
          preview4.show();
        });
        reader.readAsDataURL(file4);
      }
      if (file5) {
        const reader = new FileReader();
        reader.addEventListener('load', function () {
          preview5.attr('src', this.result);
          preview5.show();
        });
        reader.readAsDataURL(file5);
      }
    });


/***************************** Form Submit ********************************/

      $('#icaal__quote-formSubmit').submit(function(e) {
        e.preventDefault();
        console.log('test');

        let $this = $(this);
        let $response = $('.postcode-response');
        let $postcode = $('#postcode').val();

        $this.prop('disabled', true);
        $response.empty();
        $('.postcode-input').removeClass('border-red');
        $response.hide();

        $.ajax({
          url: '//api.postcodes.io/postcodes/' + $postcode,
          method: 'get'
        }).done(function(response) {
          postcode = response.result.postcode;
          icaalQuoteValues['postcode'] = postcode;

          var $form = $this;
          var $submit = $form.find('#completeForm');
          var $response = $form.find('.details-response');
          var $data = $form.serializeArray();
          var $files = $form.find('[type="file"]')
          var data = new FormData()

          $.each($data, function(index, field) {
            data.append(field.name, field.value)
          })

          data.append('screen_width', screen.width);
          data.append('screen_height', screen.height);
          data.append('action', 'lead_generation_form');
          data.append('services', services);
          data.append('drivers_side', driversSide);
          data.append('passengers_side', passengerSide);
          data.append('top_view', topView);
          data.append('front_view', frontView);
          data.append('rear_view', rearView);
        

          var icaal_form_attachments = $form.find('[type="file"]');
            if (icaal_form_attachments.length > 0) {
              console.log('true');
                $.each($form.find('[type="file"]'), function (index, file) {
                    var attachment_name = $(this).attr('name');
                    $.each($(this)[0].files, function (index, file) {
                        data.append(attachment_name + index, file);
                    });
                });
            }

          $submit.prop('disabled', true);
          $response.empty();

          // nextPane();

          $.ajax({
            url: '//api.clients.icaal.co.uk/forms/form_pk_t5rl3X0AxrFCXvtiBH2pEEHY',
            method: 'post',
            contentType: false,
            processData: false,
            data: data
          }).done(function (response) {
            nextPane();

            // gtag('event', 'Click', {'event_category': 'PPC Form Complete','event_label': 'Finished Quote'});

          }).fail(function (response) {
            $response.addAlert('danger', '', response.responseJSON.errors);
            $submit.prop('disabled', false);
          });

          return false;
        }).fail(function(response) {
          $('.postcode-input').addClass('border-red');
          $response.show();
          $response.text('Please enter a valid UK postcode.');
          $this.prop('disabled', false);
        });
      });
      
});


// WEBPACK FOOTER //
// ./scripts/form.js